import React from 'react';
import { FileText, Target, Users } from 'lucide-react';
import PhasePageTemplate from './PhasePageTemplate';

const PhaseDiscover = () => (
  <PhasePageTemplate
    phaseNumber="01"
    phaseName="The Discovery Form"
    tagline="We start by learning how your business actually runs. Not in theory — in practice. Twenty minutes that shape everything we build."
    heroImage="/images/generated/process-hero-discover.png"
    conceptImage="/images/generated/process-concept-discover.png"
    delivers={[
      {
        icon: <FileText className="w-6 h-6" />,
        title: 'A Complete Business Profile',
        desc: 'Your tools, your team structure, your communication style, and what you actually need handled. This is the foundation your agent is built on.',
      },
      {
        icon: <Target className="w-6 h-6" />,
        title: 'Your Integration Map',
        desc: 'We identify exactly which platforms your business runs on — CRM, scheduling, communication, accounting — so we know what to connect.',
      },
      {
        icon: <Users className="w-6 h-6" />,
        title: 'Your Agent Design Inputs',
        desc: 'The intake form directly informs your agent\'s identity, priorities, and knowledge base. Generic is useless — this is how we avoid it.',
      },
    ]}
    whyTitle="Generic AI is useless. So we don't build it."
    whyBody="An AI agent that doesn't know how you run your business is just a chatbot. Before we build anything, we need to understand your workflow — the tools you use, the team you manage, the friction you feel every day. The Discovery Form is how we get there. Most clients complete it in under 30 minutes. It's the most important 30 minutes in the entire process."
    experienceTitle="Simple. Mostly us doing the thinking."
    experienceBody="You fill out a form at your client portal. It covers your business structure, your core tools, the tasks that eat your time, and what success looks like 90 days from now. Some clients sit down and knock it out solo. Others prefer to walk through it with us on a quick call. Either way works — we follow your lead."
    experienceHighlights={[
      'Access your portal at any time — no deadline pressure',
      'Answer at your own pace, save progress and return later',
      'We reach out if anything needs clarification before your Strategy Call',
    ]}
    timeline="20–30 minutes"
    mockupImage="/images/generated/mockup-intake-form.jpg"
    mockupCaption="The intake form — 20 minutes that shape everything we build."
    todoItems={[
      'Complete the intake form in your client portal',
      'Be specific — the more detail, the sharper your agent',
      'That\'s it. We handle everything from here.',
    ]}
    prevPhase={null}
    nextPhase={{ name: 'The Strategy Call', href: '/process/strategy-call' }}
  />
);

export default PhaseDiscover;
